package org.hs_soft.runmynesto.pages.home.sub_page.statistic.mvi

import androidx.compose.runtime.NoLiveLiterals
import kotlinx.browser.window
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.datetime.Clock
import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.TimeZone
import kotlinx.datetime.minus
import kotlinx.datetime.toLocalDateTime
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.errorMessage
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.PeriodDaysEnum
import org.hs_soft.runmynesto.domain.model.home.statistic.StatisticHeaderEnum
import org.hs_soft.runmynesto.domain.model.home.statistic.tabs.abc_statics.ABCStatisticGroupByEnum
import org.hs_soft.runmynesto.domain.model.home.statistic.tabs.search_bill.statistic_data.BillSearchStatisticDataItem
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.domain.requestHandler
import org.hs_soft.runmynesto.domain.usecase.home.GetSavedCheckOutUseCase
import org.hs_soft.runmynesto.domain.usecase.statistic.abs_statistic.ABCStatisticDataUseCase
import org.hs_soft.runmynesto.domain.usecase.statistic.abs_statistic.InitABCStatisticUseCase
import org.hs_soft.runmynesto.domain.usecase.statistic.search_bill.BillPdfUseCase
import org.hs_soft.runmynesto.domain.usecase.statistic.search_bill.BillSearchStatisticDataUseCase
import org.hs_soft.runmynesto.domain.usecase.statistic.search_bill.InitSearchBillUseCase
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.extractAllCashRegisters
import org.hs_soft.runmynesto.domain.util.extractDate
import org.hs_soft.runmynesto.domain.util.extractTime
import org.hs_soft.runmynesto.domain.util.formatToTwoDecimals
import org.hs_soft.runmynesto.domain.util.getFromDate
import org.hs_soft.runmynesto.domain.util.getToDate
import org.hs_soft.runmynesto.domain.util.getUpdatedSelectedYear
import org.hs_soft.runmynesto.domain.util.helper.BaseViewModel
import org.hs_soft.runmynesto.domain.util.jsObject
import org.hs_soft.runmynesto.domain.util.withTokenRefresh
import org.hs_soft.runmynesto.modules.ExcelJS
import org.hs_soft.runmynesto.modules.FileSaver
import org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.mvi.ClosingReportsEvent
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

class StatisticViewModel(
    private val requestManager: RequestManager,
    private val initSearchBillUseCase: InitSearchBillUseCase,
    private val getSavedCheckOutUseCase: GetSavedCheckOutUseCase,
    private val billSearchStatisticDataUseCase: BillSearchStatisticDataUseCase,
    private val initABCStatisticUseCase: InitABCStatisticUseCase,
    private val abcStatisticDataUseCase: ABCStatisticDataUseCase,
    private val billPdfUseCase: BillPdfUseCase,
): BaseViewModel()
{
    private val _state = MutableStateFlow(StatisticState())
    val state: StateFlow<StatisticState> = _state
    private var tempCheckoutList: List<Children>? = listOf()
    private  var tempBillSearchStatisticData:List<BillSearchStatisticDataItem> ?=null
    private var tempBillSearchStatisticItemDetail:BillSearchStatisticDataItem?=null

    override fun clear() {
        requestManager.cancelAll()
    }

    init {
        initCalendar()
    }


    private fun initCalendar()
    {
        val today = Clock.System.now().toLocalDateTime(TimeZone.UTC).date

        _state.value = _state.value.copy(
            selectedDate = MonthModel(
                dayNumber = today.dayOfMonth,
                monthName = today.month.name,
                yearNumber = today.year,
                monthNumber = today.monthNumber
            ),

        )
        _state.value=_state.value.copy(
            selectedFromDate = state.value.selectedDate?.let { getFromDate(it) },
            selectedToDate = state.value.selectedDate?.let { getFromDate(it) }
        )
    }

    fun onEvent(event: StatisticEvent){
        when(event){

            is StatisticEvent.DismissErrorDialog->{
                _state.value=_state.value.copy(
                    errorInfo = null,
                )
            }

            is StatisticEvent.CloseAllDialogs->{
                closeAllDialogs()
            }

            is StatisticEvent.SetPdfPreviewDialogStatus->{
                _state.value=_state.value.copy(
                    showPdfPreviewDialog = event.status
                )
                if (!event.status)
                    _state.value=_state.value.copy(
                        billPdfResult = null
                    )
            }

            is StatisticEvent.ExportExcelFile->{
                exportToExcel(data=event.data)
            }

            is StatisticEvent.BillPdf->{
                billPdf(
                    billDate=event.billDate,
                    billNumber=event.billNumber,
                    cashRegisterId=event.cashRegisterId,
                )
            }

//            is StatisticEvent.OnSearchInSelectedBillSearchItem->{
//                searchInSelectedBillSearchItem(searchValue = event.searchValue)
//            }

            is StatisticEvent.OnSelectBillSearchStatisticItem->{
                onSelectBillSearchStatisticItem(item=event.item)
            }

            is StatisticEvent.OnSearchInBillSearchItems->{
                searchInBillSearchItems(searchValue=event.searchValue)
            }

            is StatisticEvent.SetCheckoutDialogStatus->{
                setCheckoutDialogStatus(status=event.status)
            }

            is StatisticEvent.OnSearchCheckoutItems->{
                searchCheckoutItems(value = event.value)
            }

            is StatisticEvent.UpdateSelectedCheckout->{
                updateSelectedCheckout(
                    selectedCashRegisterIds=event.cashRegisterIds,
                    cashList = state.value.cashList?: listOf()
                )
            }

            is StatisticEvent.InitABCStatistic->{
                initABCStatistic(
                    to=state.value.selectedToDate?:"",
                    from=state.value.selectedFromDate?:"",
                    groupBy=state.value.selectedGroupBy.value,
                    cashRegisterIds=state.value.cashRegisters?.mapNotNull { it.id }?: listOf() ,
                    productIds= listOf()
                )

            }

            is StatisticEvent.OnTabHeaderClick->{
                onTabHeaderClick(tab=event.tab)
            }

            is StatisticEvent.OnSelectFromDate->{
                onSelectFromDate(
                    selectedDate = event.selectedFromDate,
                )
            }
            is StatisticEvent.OnSelectToDate->{
                onSelectToDate(
                    selectedDate = event.selectedToDate,
                )
            }


            is StatisticEvent.SetFromCalendarFilterDialogStatus->{
                setCalendarFromFilterDialogStatus(status=event.status)
            }

            is StatisticEvent.SetToCalendarFilterDialogStatus->{
                setCalendarToFilterDialogStatus(status=event.status)
            }

            is StatisticEvent.SetNewCalendarHeaderYear->{

                _state.value=_state.value.copy(
                    selectedCalendarHeaderYear = event.year
                )
            }

            is StatisticEvent.SubmitStatisticCalendarFilter->{
                submitStatisticCalendarFilter(
                    from=event.from,
                    to=event.to,
                )
            }

            is StatisticEvent.SubmitStatisticDaysFilter->{
                submitStatisticDaysFilter(
                    from=event.from,
                    to=event.to,
                    selectedPeriodType=event.periodDaysType,
                )
            }

            is StatisticEvent.SetDaysFilterDialogStatus->{
                setDaysFilterDialogStatus(status=event.show)
            }

            is StatisticEvent.GetCashRegisterIds -> {
                getCashRegisters()
            }

            is StatisticEvent.InitBillSearch->{
                initSearchBill(
                    from = state.value.selectedFromDate?:"",
                    to=state.value.selectedToDate?:"",
                    cashRegisterIds = state.value.cashRegisters
                        ?.mapNotNull { it.id }?: listOf(),
                    billNumberFrom = event.billNumberFrom,
                    billNumberTo = event.billNumberTo,
                    totalFrom = event.totalFrom,
                    totalTo = event.totalTo,
                )
            }

            is StatisticEvent.UpdateGroupBy->{
                updateGroupBy(groupBy=event.groupBy)
            }


        }

        

    }

    private fun closeAllDialogs() {
        _state.value=_state.value.copy(
            showFromCalendarFilterDialog = false,
            showToCalendarFilterDialog = false,
            showPdfPreviewDialog = false,
            showCheckoutDialog = false,
            showDaysFilterDialog = false,
            showReportsTableAndDevices = false,
        )
    }



    @NoLiveLiterals
    private fun exportToExcel(data: List<BillSearchStatisticDataItem>) {
        val workbook = ExcelJS.Workbook()
        val worksheet = workbook.addWorksheet("Bill Search Data")


        val table = jsObject<ExcelJS.Table> {
            name = "BillSearchTable"
            ref = "A1"
            headerRow = true
            totalsRow = false
            columns = arrayOf(
                jsObject<Any> { name ="Date"  },
                jsObject<Any> { name = "Time" },
                jsObject<Any> { name = "Cash register name" },
                jsObject<Any> { name = "Number" },
                jsObject<Any> { name = "Username" },
                jsObject<Any> { name = "Cancellation" },
                jsObject<Any> { name = "Total" }
            )
            rows = data.map { item ->
                arrayOf(
                    extractDate(item.dateTime ?: ""),
                    extractTime(item.dateTime ?: ""),
                    item.cashRegisterName ?: "",
                    item.number.toString(),
                    item.userName ?: "",
                    if (item.isCancelled == true) "Cancelled" else "Not cancelled",
                    formatToTwoDecimals(item.total)
                )
            }.toTypedArray()
        }

        worksheet.addTable(table)

        workbook.xlsx.writeBuffer().then { buffer ->
            val blob = Blob(arrayOf(buffer), BlobPropertyBag(type = "application/octet-stream"))
            FileSaver.saveAs(blob, "BillSearchData.xlsx")
        }
    }

    private fun billPdf(
        billDate: String,
        billNumber: Int,
        cashRegisterId: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    billPdfUseCase(
                        billDate = billDate,
                        billNumber = billNumber,
                        cashRegisterId = cashRegisterId
                    )
                },
                onSuccess = { result ->
                    val url = result.data?.cashAssist?.getBillPdf?.url
                    if (url != null) {
                        val fileName = "bill_$billNumber.pdf"
                        _state.value = _state.value.copy(billPdfResult = url)

                        if (state.value.billPdfResult != null) {
                            window.open(url, "_blank")?.focus()
                        }
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }



    private fun searchInBillSearchItems(searchValue: String) {
        val searchTitle = searchValue.lowercase().removeSuffix("enter")

        val result = tempBillSearchStatisticData?.filter { item ->
            listOf(
                item.dateTime,
                item.cashRegisterName,
                item.number,
                item.tableNumber,
                item.userName,
                item.total.toString()
            ).any { fieldValue ->
                fieldValue?.lowercase()?.contains(searchTitle) ?:false
            }
        } ?: listOf()

        _state.value = _state.value.copy(
            billSearchStatisticData = result
        )

    }

//    private fun searchInSelectedBillSearchItem(searchValue: String) {
//        val searchTitle = searchValue.lowercase().removeSuffix("enter")
//
//        val result = tempBillSearchStatisticItemDetail?.items?.filter { item ->
//            listOf(
//                item?.amount?.toString(),
//                item?.product?.code,
//                item?.product?.name,
//                item?.price?.toString(),
//                item?.discountPercent?.toString(),
//                item?.codeMWSt,
//                item?.mul1?.toString(),
//                item?.total?.toString()
//            ).any { fieldValue ->
//                fieldValue?.lowercase()?.contains(searchTitle) ?: false
//            }
//        } ?: listOf()
//
//        _state.value = _state.value.copy(
//            selectedBillSearchStatisticItem = state.value.selectedBillSearchStatisticItem?.copy(
//                items = result
//            )
//        )
//    }


    private fun onSelectBillSearchStatisticItem(item: BillSearchStatisticDataItem) {

        _state.value=_state.value.copy(
            selectedBillSearchStatisticItem = item
        )
        tempBillSearchStatisticItemDetail=item
    }

    private fun setCheckoutDialogStatus(status: Boolean) {
        _state.value=_state.value.copy(
            showCheckoutDialog = status
        )
    }

    private fun searchCheckoutItems(value: String) {
        if (value.isEmpty()) {
            _state.value = _state.value.copy(
                cashList = tempCheckoutList,
                isDevicesExpandAll = false
            )
            return
        }

        val searchTerm = value.lowercase()
        val searchedList = tempCheckoutList?.mapNotNull { model ->
            val filteredChildrenX = model.children?.mapNotNull { childX ->
                val filteredChildrenXX = childX.children?.mapNotNull { childXX ->
                    val filteredChildrenXXX = childXX.children.filter { childXXX ->
                        childXXX.name?.lowercase()?.contains(searchTerm) == true
                    }

                    if (childXX.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenXXX.isNotEmpty()) {
                        childXX.copy(children = filteredChildrenXXX)
                    } else null
                }

                if (childX.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenXX?.isNotEmpty() == true) {
                    childX.copy(children = filteredChildrenXX)
                } else null
            }

            if (model.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenX?.isNotEmpty() == true) {
                model.copy(children = filteredChildrenX)
            } else null
        }

        _state.value = _state.value.copy(
            cashList = searchedList,
            isDevicesExpandAll = true
        )
    }

    private fun updateSelectedCheckout(
        selectedCashRegisterIds: List<String>,
        cashList:List<Children>,
    ) {
        val allCashRegisters = extractAllCashRegisters(cashList)
        val filteredCashRegisters = allCashRegisters.filter { it.id in selectedCashRegisterIds }

        _state.value = _state.value.copy(
            selectedCashRegisterIds = selectedCashRegisterIds,
            cashRegisters = filteredCashRegisters
        )




    }

    private fun updateGroupBy(groupBy: ABCStatisticGroupByEnum) {
        _state.value=_state.value.copy(
            selectedGroupBy=groupBy
        )
    }

    private fun initABCStatistic(
        to: String,
        from: String,
        groupBy: String,
        cashRegisterIds: List<String>,
        productIds: List<String>
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(abcStatisticCalculationLoading = isLoading)
                },
                callRequest = {
                    initABCStatisticUseCase(
                        from = from,
                        to = to,
                        groupBy = groupBy,
                        cashRegisterIds = cashRegisterIds,
                        productIds = productIds
                    )
                },
                onSuccess = { result ->
                    val requestId = result.data?.cashAssist?.initAbcStatistics ?: ""
                    getABCStatisticData(requestId = requestId)
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getABCStatisticData(requestId: String) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(abcStatisticCalculationLoading = isLoading)
                },
                callRequest = {
                    abcStatisticDataUseCase(requestId = requestId)
                },
                onSuccess = { result ->
                    val data = result.data?.cashAssist?.getStatisticsData?.data
                    if (data != null) {
                        _state.value = _state.value.copy(abcStatisticData = data)
                    } else {
                        getABCStatisticData(requestId = requestId)
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun initSearchBill(
        from: String,
        to: String,
        cashRegisterIds: List<String>,
        billNumberFrom: Int?,
        billNumberTo: Int?,
        totalFrom: Int?,
        totalTo: Int?,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(billSearchCalculationLoading = isLoading)
                },
                callRequest = {
                    initSearchBillUseCase(
                        billNumberFrom = billNumberFrom,
                        billNumberTo = billNumberTo,
                        from = from,
                        to = to,
                        totalFrom = totalFrom,
                        totalTo = totalTo,
                        cashRegisterIds = cashRegisterIds,
                        products = listOf()
                    )
                },
                onSuccess = { result ->
                    _state.value=_state.value.copy(
                        selectedBillSearchStatisticItem = null,
                    )
                    val requestId = result.data?.cashAssist?.initSearchBills ?: ""
                    getBillSearchStatisticData(requestId = requestId)
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getBillSearchStatisticData(
        requestId: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(billSearchCalculationLoading = isLoading)
                },
                callRequest = {
                    billSearchStatisticDataUseCase(requestId = requestId)
                },
                onSuccess = { result ->
                    val data = result.data?.cashAssist?.getStatisticsData?.data
                    if (data != null) {
                        _state.value = _state.value.copy(billSearchStatisticData = data)
                        tempBillSearchStatisticData = data
                    } else {
                        getBillSearchStatisticData(requestId = requestId)
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getCashRegisters() {
        launch {
            if (state.value.cashRegisters == null) {
                requestHandler(
                    callRequest = {
                        getSavedCheckOutUseCase()
                    },
                    onSuccess = { result ->
                        val cashList = result?.data?.cashAssist?.children
                        _state.value = _state.value.copy(
                            cashRegisters = extractAllCashRegisters(cashList = cashList),
                            cashList = cashList
                        )
                        tempCheckoutList = state.value.cashList
                    },
                    onError = { result ->
                        showRequestError(result?.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun setDaysFilterDialogStatus(status: Boolean) {
        _state.value = _state.value.copy(
            showDaysFilterDialog =status,
            showFromCalendarFilterDialog = false,
            showToCalendarFilterDialog = false,

        )

    }

    private fun submitStatisticDaysFilter(
        from: String,
        to: String,
        selectedPeriodType: PeriodDaysEnum,
    ) {
        _state.value=_state.value.copy(
            showDaysFilterDialog = false,
            selectedFromDate = from,
            selectedToDate = to,
            selectedPeriodType = selectedPeriodType,
        )
        val today = Clock.System.now().toLocalDateTime(TimeZone.UTC).date

        if (selectedPeriodType == PeriodDaysEnum.TODAY) {
            _state.value = _state.value.copy(
                selectedDate = MonthModel(
                    dayNumber = today.dayOfMonth,
                    monthName = today.month.name,
                    yearNumber = today.year,
                    monthNumber = today.monthNumber
                )
            )
        } else if (selectedPeriodType == PeriodDaysEnum.YESTERDAY) {
            val yesterday = today.minus(1, DateTimeUnit.DAY)
            _state.value = _state.value.copy(
                selectedDate = MonthModel(
                    dayNumber = yesterday.dayOfMonth,
                    monthName = yesterday.month.name,
                    yearNumber = yesterday.year,
                    monthNumber = yesterday.monthNumber
                )
            )
        }else{
            _state.value=_state.value.copy(
                selectedDate = null
            )
        }



    }
    private fun submitStatisticCalendarFilter(
        from: String, to: String
    ) {
        _state.value=_state.value.copy(
            selectedToDate =  to.getUpdatedSelectedYear(state.value.selectedCalendarHeaderYear),
            selectedFromDate = from.getUpdatedSelectedYear(state.value.selectedCalendarHeaderYear),
        )

    }

    private fun onSelectFromDate(
        selectedDate: MonthModel,
    ) {
        _state.value=_state.value.copy(
            selectedFromDate = getFromDate( selectedDate),
        )


    }

    private fun onSelectToDate(
        selectedDate: MonthModel,
    ) {
        _state.value=_state.value.copy(
            selectedToDate = getToDate( selectedDate)
        )

    }

    private fun setCalendarFromFilterDialogStatus(status: Boolean) {
        _state.value = _state.value.copy(
            showFromCalendarFilterDialog = status,
            showDaysFilterDialog = false,
            showToCalendarFilterDialog = false
        )
    }
    private fun setCalendarToFilterDialogStatus(status: Boolean) {
        _state.value = _state.value.copy(
            showToCalendarFilterDialog = status,
            showDaysFilterDialog = false,
            showFromCalendarFilterDialog = false,
        )
    }



    private fun onTabHeaderClick(tab: StatisticHeaderEnum) {
        _state.value=_state.value.copy(
            selectedTab = tab
        )

    }


    private fun showRequestError(result:List<GeneralError?>?) {
        _state.value = _state.value.copy(
            errorInfo = errorMessage(result)
        )
    }
    private fun showException(e: Exception) {
        if (!e.toString().contains(ApiUtils.Status.ERR_401)){
            _state.value = _state.value.copy(
                errorInfo = e.message.toString()
            )
        }
    }


}